import React, {useState, Fragment, useEffect} from 'react';
import { Card, CardContent, } from '@mui/material';
import { Cancel, Save } from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import { nuevoOActualizarRegistroPersonalizado, obtenerDepartamentosPersonalizado, obtenerMunicipiosPersonalizado, obtenerRegistrosPersonalizado} from 'store/actions/customAction';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import Formulario from 'components/formulario';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { nombreDeAcciones } from 'constantes';
import ServiciosDelAPI from 'servicios/ServiciosDelAPI';

const EditarDatosDeLaPantalla = ({title, openFullScreenDialog, handleClose, datossDelTarifario, accionRegistroEditado}) => {
    const {datosGenerales} = useSelector((state) => state);
    const dispatch = useDispatch();
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeError: 'error', tipoDeMensaje: '', abrirRespuesta: false, });
    const[cargandoSolicitud, setcargandoSolicitud] = useState(false);
    const [catalogoSentidoVisualizacion] = useState('catalogoSentidoVisualizacion');
    const [catalogoDepartamentos] = useState('catalogoDepartamentos');
    const [catalogoMunicipios] = useState('catalogoMunicipios');

    useEffect(() => {
      obtenerSentidoDeVisualizacion();
      obtenerDepartamentos();
    },[])
  
    const obtenerSentidoDeVisualizacion = async () => {
      const copiaDeCampos = Object.assign({}, camposDelFormulario);
  
      if(datosGenerales.tipoSentidoDeVisualizacion.length > 0) {
          copiaDeCampos.sentidoDeVisualizacion.list = datosGenerales.tipoSentidoDeVisualizacion?.map( ({id, descripcion}) => ({id , name: descripcion}) );
          return setCamposDelFormulario(copiaDeCampos);
      }
  
      setcargandoSolicitud(true);
      let respuesta = await dispatch(obtenerRegistrosPersonalizado({
          controller: catalogoSentidoVisualizacion,
          validateIfDataExists: true,
          stateInStore: datosGenerales.tipoSentidoDeVisualizacion,
          dispatchAction: nombreDeAcciones.SETEAR_TIPO_DE_VISUALIZACION,
      }));
  
      setcargandoSolicitud(false);
  
      if(respuesta?.error || respuesta?.data?.length === 0) return setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });
  
      copiaDeCampos.sentidoDeVisualizacion.list = respuesta?.data?.map( ({id, descripcion}) => ({id , name: descripcion}) )
      setCamposDelFormulario(copiaDeCampos);
    }
  
    const obtenerDepartamentos =async ()=> { 
      setcargandoSolicitud(true);
      const copiaDeCampos = Object.assign({}, camposDelFormulario);
  
      if(datosGenerales.departamentos.length > 0) {
          if(datosGenerales.departamentos.length > 22 ) datosGenerales.departamentos.shift()
        copiaDeCampos.departamento.list = datosGenerales.departamentos?.map( ({id, nombre}) => ({id, name: nombre}) );
        setcargandoSolicitud(false);
        return setCamposDelFormulario(copiaDeCampos);
      }
  
      const dataCustomFetch = {
          controller: catalogoDepartamentos,
          validateIfDataExists: true,
          stateInStore : datosGenerales?.departamentos,
          dispatchAction:  nombreDeAcciones.OBTENER_DEPARTAMENTOS,
      }
  
      const respuesta = await dispatch(obtenerDepartamentosPersonalizado(dataCustomFetch));
      setcargandoSolicitud(false);
  
      if(respuesta?.error) setDatosDeRespuesta({ tipoDeAlerta: 'error', mensajeDeAlerta: respuesta?.error?.message || "", mostrarRespuesta: true, });
  
      let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
      copiaDeCampos.departamento.list = datos;
      setCamposDelFormulario(copiaDeCampos);
    };
  
    const obtenerMunicipios =async ({target}) => {
        const newState = Object.assign({}, camposDelFormulario);
  
        if(!target.value) {
            newState.municipio.list = [];
            newState.municipio.value = null;
            return;
        };
  
        setcargandoSolicitud(true);
        const dataCustomFetch = {
            controller: catalogoMunicipios,
            stateInStore : datosGenerales?.catalogos?.municipios,
            dispatchAction: nombreDeAcciones.OBTENER_MUNICIPIOS,
            departamentoID: target?.value
        }
        ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.clear();
        ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.setOperator("and");
        ServiciosDelAPI[catalogoMunicipios].metodoDeBusqueda.addEquals("departamento.id", target?.value);
        const respuesta = await dispatch(obtenerMunicipiosPersonalizado(dataCustomFetch));
  
        setcargandoSolicitud(false);
        if(respuesta?.error) {
            newState.municipio.list = [];
            newState.municipio.value = null;
            setDatosDeRespuesta({ errorType: 'error', messageType: respuesta.error?.message || "No se pudieron obtener los municipios", openResponse: true, });
        }
  
        let datos = respuesta?.data?.map( ({id, nombre}) => ({id , name: nombre}) )
        newState.municipio.list = datos;
        newState.municipio.value = null;
        setCamposDelFormulario(newState);
    };

    const { departamento, municipio, alto, ancho, coordenadas, sentidoDeVisualizacion, descripcionUbicacion, imagenDePantalla} = datossDelTarifario;


    const [camposDelFormulario, setCamposDelFormulario] = React.useState({
      tituloCobertura:{
        idelement: "tituloCobertura", title:'Departamento y Municipio', position:"center", elementType:'titulo', showTitleForm: true,  name: "tituloCobertura", value: "", isError:false,
      },
      departamento: {
          idelement: "departamento", value: departamento ? {id: departamento?.id, name: departamento?.nombre} : null, label: "Seleccione el departamento *", pattern:"^[0-9]{1,}$", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: obtenerMunicipios, width: '40%', marginTop: '10px'
      },
      municipio: {
          idelement: "municipio", value: municipio ? {id: municipio?.id, name: municipio?.nombre} : null, label: "Seleccione el municipio *", pattern:"^[0-9]{1,}$", validators: ['required'],
          errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '40%', marginTop: '10px'
      },
      tituloPantallaDigital:{
          idelement: "tituloPantallaDigital", title:'Datos de la pantalla digital', position:"center", elementType:'titulo', showTitleForm: true, name: "tituloPantallaDigital", value: "", isError:false,
      },
      anchoPantalla: {
          idelement: "anchoPantalla", value: ancho || "", label: `Ancho (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"anchoPantalla", 'disabled': false, width: '33%',
      },
      altoPantalla: {
          idelement: "altoPantalla", value: alto || "", label: `Alto (cm) *`, pattern:"^\\d+(.\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"altoPantalla", 'disabled': false, width: '33%',
      },
      coordenadasDeUbicacion: {
          idelement: "coordenadasDeUbicacion", value: coordenadas || "", label: `Coordenadas de ubicación *`,
          pattern:"^([-+]?\\d{1,2}[.]\\d+),\\s*([-+]?\\d{1,3}[.]\\d+)?$", validators: ['required'], errorMessages:['El campo es requerido y solo números'], isError:false, elementType:'texto', name:"coordenadasDeUbicacion", 'disabled': false, width: '33%',
      },
      sentidoDeVisualizacion: {
        idelement: "sentidoDeVisualizacion", value: sentidoDeVisualizacion ? {id: sentidoDeVisualizacion?.id, name: sentidoDeVisualizacion?.descripcion} : null, label: "Sentido de visualización *", pattern:"^[1-9][0-9]*$", validators: ['required'],
        errorMessages:['Seleccione una opción'], isError:false, showSelectAutoComplete: true, elementType:'autoCompletar', list: [], handler: undefined, width: '50%', marginTop: '0'
      },
      imagenDeLaPantalla:{
        idelement: "imagenDeLaPantalla", value: imagenDePantalla ? imagenDePantalla.includes('base64,') ? imagenDePantalla : `data:image/jpeg;base64,${imagenDePantalla}` : "",label: "Imagen de la pantalla", validators: {required: true,  size: "8 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"imagenDeLaPantalla", fileWidth: true, src: '', multiple: false, accept:".png, .jpg", showInMovil: true, width: '49%', type: "file"
      },
      ubicacionDePantalla:{
          idelement: "ubicacionDePantalla", value: descripcionUbicacion|| "", label: `Ubicación de la pantalla digital`, pattern:"^[\\w\\s\\á-úÁ-Ú\\-\\,.!#$%&<>~^'=?¿+:;_“”()-*_/@]{4,2000}$", validators: ['required'],
          errorMessages:['El campo es requerido'], isError:false, elementType:'areaTexto','disabled':false, fullWidth: true, name: "ubicacionDePantalla", width: '100%'
      },
    });

    const guardarDatos = async (datosDelFormulario) => {
      const { departamento, municipio, anchoPantalla, altoPantalla, coordenadasDeUbicacion, sentidoDeVisualizacion, imagenDeLaPantalla, ubicacionDePantalla } = datosDelFormulario;

        const objetoAEnviar = {
            "idMedioDeComunicacion": datossDelTarifario.medioDeComunicacion?.id,
            "nitEmpresa": datossDelTarifario.medioDeComunicacion?.nit_empresa,
            alto: altoPantalla,
            ancho: anchoPantalla,
            coordenadas: coordenadasDeUbicacion,
            sentidoVisualizacion: sentidoDeVisualizacion.id,
            departamento: departamento.id,
            municipio: municipio.id,
            descripcionUbicacion: ubicacionDePantalla,
            logo: imagenDeLaPantalla
        }

        setcargandoSolicitud(true);

        const datosAEnviar = { controller: "tarifarioDePantallasDigitales", action: "editar", data: objetoAEnviar, nombreDelMetodo: "editar/informacionGeneral" };

        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(datosAEnviar));
        setcargandoSolicitud(false);

        if(respuesta?.error) return setDatosDeRespuesta({ tipoDeError: 'error', tipoDeMensaje: respuesta?.error?.message || "Ocurrió un inconveniente, Intente de nuevo!", abrirRespuesta: true, });
        accionRegistroEditado(respuesta?.data)
    }

    const [listadoDeBotones]= React.useState({
        "guardarDatos":{"label":"Guardar Datos", "icon": <Save />, "callback":guardarDatos,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
        "cancelar":{"label":"Cancelar", "icon": <Cancel />,"callback":handleClose,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #B90000 30%, #E07777 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px",  disabled: false,
                isCancel: true,
        },
    });

    const cerrarAlerta = (_, reason) => {
        if (reason === 'clickaway') {return}
        setDatosDeRespuesta({ tipoDeError: 'error', tipoDeMensaje: "", abrirRespuesta: false, });
    };

    const { tipoDeError, tipoDeMensaje, abrirRespuesta} = datosDeRespuesta;

    return (
        <DialogoPantallaCompleta
            openFullScreenDialog={openFullScreenDialog}
            handleClose={handleClose}
            title={title}
            fullscreen={true}
            showButtonClose={false}
            showIconButton={true}
        >
            <Fragment>
                {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
                <AlertaDeRespuesta type={tipoDeError} content={tipoDeMensaje} open={abrirRespuesta} handClose={cerrarAlerta}/>
                <Card>
                    <CardContent>
                        <Formulario
                            elements={camposDelFormulario}
                            buttonList={listadoDeBotones}
                        />
                    </CardContent>
                </Card>
            </Fragment>
        </DialogoPantallaCompleta>
    );
}

export default EditarDatosDeLaPantalla;